
export const PAYS_AFRIQUE = [
  { code: 'ZA', nom: 'Afrique du Sud', capitale: 'Pretoria / Le Cap', drapeau: '🇿🇦' },
  { code: 'DZ', nom: 'Algérie', capitale: 'Alger', drapeau: '🇩🇿' },
  { code: 'AO', nom: 'Angola', capitale: 'Luanda', drapeau: '🇦🇴' },
  { code: 'BJ', nom: 'Bénin', capitale: 'Porto-Novo', drapeau: '🇧🇯' },
  { code: 'BW', nom: 'Botswana', capitale: 'Gaborone', drapeau: '🇧🇼' },
  { code: 'BF', nom: 'Burkina Faso', capitale: 'Ouagadougou', drapeau: '🇧🇫' },
  { code: 'BI', nom: 'Burundi', capitale: 'Gitega', drapeau: '🇧🇮' },
  { code: 'CM', nom: 'Cameroun', capitale: 'Yaoundé', drapeau: '🇨🇲' },
  { code: 'CV', nom: 'Cap-Vert', capitale: 'Praia', drapeau: '🇨🇻' },
  { code: 'CF', nom: 'République Centrafricaine', capitale: 'Bangui', drapeau: '🇨🇫' },
  { code: 'KM', nom: 'Comores', capitale: 'Moroni', drapeau: '🇰🇲' },
  { code: 'CG', nom: 'République du Congo', capitale: 'Brazzaville', drapeau: '🇨🇬' },
  { code: 'CD', nom: 'R.D. Congo', capitale: 'Kinshasa', drapeau: '🇨🇩' },
  { code: 'CI', nom: 'Côte d\'Ivoire', capitale: 'Yamoussoukro / Abidjan', drapeau: '🇨🇮' },
  { code: 'DJ', nom: 'Djibouti', capitale: 'Djibouti', drapeau: '🇩🇯' },
  { code: 'EG', nom: 'Égypte', capitale: 'Le Caire', drapeau: '🇪🇬' },
  { code: 'ER', nom: 'Érythrée', capitale: 'Asmara', drapeau: '🇪🇷' },
  { code: 'SZ', nom: 'Eswatini', capitale: 'Mbabane / Lobamba', drapeau: '🇸🇿' },
  { code: 'ET', nom: 'Éthiopie', capitale: 'Addis-Abeba', drapeau: '🇪🇹' },
  { code: 'GA', nom: 'Gabon', capitale: 'Libreville', drapeau: '🇬🇦' },
  { code: 'GM', nom: 'Gambie', capitale: 'Banjul', drapeau: '🇬🇲' },
  { code: 'GH', nom: 'Ghana', capitale: 'Accra', drapeau: '🇬🇭' },
  { code: 'GN', nom: 'Guinée', capitale: 'Conakry', drapeau: '🇬🇳' },
  { code: 'GW', nom: 'Guinée-Bissau', capitale: 'Bissau', drapeau: '🇬🇼' },
  { code: 'GQ', nom: 'Guinée Équatoriale', capitale: 'Ciudad de la Paz', drapeau: '🇬🇶' },
  { code: 'KE', nom: 'Kenya', capitale: 'Nairobi', drapeau: '🇰🇪' },
  { code: 'LS', nom: 'Lesotho', capitale: 'Maseru', drapeau: '🇱🇸' },
  { code: 'LR', nom: 'Liberia', capitale: 'Monrovia', drapeau: '🇱🇷' },
  { code: 'LY', nom: 'Libye', capitale: 'Tripoli', drapeau: '🇱🇾' },
  { code: 'MG', nom: 'Madagascar', capitale: 'Antananarivo', drapeau: '🇲🇬' },
  { code: 'MW', nom: 'Malawi', capitale: 'Lilongwe', drapeau: '🇲🇼' },
  { code: 'ML', nom: 'Mali', capitale: 'Bamako', drapeau: '🇲🇱' },
  { code: 'MA', nom: 'Maroc', capitale: 'Rabat', drapeau: '🇲🇦' },
  { code: 'MU', nom: 'Maurice', capitale: 'Port-Louis', drapeau: '🇲🇺' },
  { code: 'MR', nom: 'Mauritanie', capitale: 'Nouakchott', drapeau: '🇲🇷' },
  { code: 'MZ', nom: 'Mozambique', capitale: 'Maputo', drapeau: '🇲🇿' },
  { code: 'NA', nom: 'Namibie', capitale: 'Windhoek', drapeau: '🇳🇦' },
  { code: 'NE', nom: 'Niger', capitale: 'Niamey', drapeau: '🇳🇪' },
  { code: 'NG', nom: 'Nigeria', capitale: 'Abuja', drapeau: '🇳🇬' },
  { code: 'UG', nom: 'Ouganda', capitale: 'Kampala', drapeau: '🇺🇬' },
  { code: 'RW', nom: 'Rwanda', capitale: 'Kigali', drapeau: '🇷🇼' },
  { code: 'ST', nom: 'São Tomé-et-Príncipe', capitale: 'São Tomé', drapeau: '🇸🇹' },
  { code: 'SN', nom: 'Sénégal', capitale: 'Dakar', drapeau: '🇸🇳' },
  { code: 'SC', nom: 'Seychelles', capitale: 'Victoria', drapeau: '🇸🇨' },
  { code: 'SL', nom: 'Sierra Leone', capitale: 'Freetown', drapeau: '🇸🇱' },
  { code: 'SO', nom: 'Somalie', capitale: 'Mogadiscio', drapeau: '🇸🇴' },
  { code: 'SD', nom: 'Soudan', capitale: 'Khartoum', drapeau: '🇸🇩' },
  { code: 'SS', nom: 'Soudan du Sud', capitale: 'Juba', drapeau: '🇸🇸' },
  { code: 'TZ', nom: 'Tanzanie', capitale: 'Dodoma', drapeau: '🇹🇿' },
  { code: 'TD', nom: 'Tchad', capitale: 'N\'Djamena', drapeau: '🇹🇩' },
  { code: 'TG', nom: 'Togo', capitale: 'Lomé', drapeau: '🇹🇬' },
  { code: 'TN', nom: 'Tunisie', capitale: 'Tunis', drapeau: '🇹🇳' },
  { code: 'ZM', nom: 'Zambie', capitale: 'Lusaka', drapeau: '🇿🇲' },
  { code: 'ZW', nom: 'Zimbabwe', capitale: 'Harare', drapeau: '🇿🇼' }
];
